import { render } from "./WxPayResultView.vue?vue&type=template&id=49d27a49&scoped=true"
import script from "./WxPayResultView.vue?vue&type=script&lang=js"
export * from "./WxPayResultView.vue?vue&type=script&lang=js"

import "./WxPayResultView.vue?vue&type=style&index=0&id=49d27a49&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d27a49"]])

export default __exports__